import { gql } from '@apollo/client';

export const SUBREGION_ZIP_FIELDS = gql`
    fragment SubregionZipFields on subregion_zip_mappings {
        mapping_id
        subregion_id
        zip
    }
`;
